let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("4d8vq")]).then(() => parcelRequire('7jsM3'));